module.exports = __webpack_public_path__ + "static/invitation-dd1396d8113294e3a539bb44388fdbf7.jpg";